import { render, staticRenderFns } from "./CommentContentStrategyProject.vue?vue&type=template&id=d324fe28&scoped=true"
import script from "./CommentContentStrategyProject.vue?vue&type=script&lang=js"
export * from "./CommentContentStrategyProject.vue?vue&type=script&lang=js"
import style0 from "./CommentContentStrategyProject.vue?vue&type=style&index=0&id=d324fe28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d324fe28",
  null
  
)

export default component.exports